import styled from "styled-components";

import theme from "../../../../theme";

import { Dot, VerticalStepBar } from ".";

export interface IStepProps {
  horizontalPadding?: number;
}

const VerticalStep = styled.li`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  justify-content: flex-end;
  color: ${theme.colors.black};
  ${({ showBottomBorder }: { showBottomBorder?: boolean }): string =>
    showBottomBorder
      ? `border-bottom: 1px solid ${theme.colors.veryLightGrey};`
      : ""}

  &.active {
    ${VerticalStepBar}:before, ${VerticalStepBar}:after {
      background-color: ${theme.colors.black};
    }
    ${Dot} {
      background-color: ${theme.colors.black};

      &:after {
        display: block;
      }
    }
    &.last-active:not(:last-of-type) ${VerticalStepBar}:after {
      background-color: ${theme.colors.brown};
    }
  }

  &:first-of-type
    ${VerticalStepBar}:before,
    &:last-of-type
    ${VerticalStepBar}:after {
    background-color: transparent;
  }
`;

export default VerticalStep;
